import { render, staticRenderFns } from "./CRMSearchResultsContainer.vue?vue&type=template&id=19958ea2&scoped=true&"
import script from "./CRMSearchResultsContainer.vue?vue&type=script&lang=js&"
export * from "./CRMSearchResultsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19958ea2",
  null
  
)

export default component.exports